export const FLOATING_WIDGET_ACTION_CONSTS = {
  SET_STATUS_WIDGET: 'SET_STATUS_WIDGET',
};

export const FLOATING_WIDGET_EVENT_ID = 'onStateChange_floating_widget_231d2';

export const FLOATING_WIDGET_EVENT = new Event(FLOATING_WIDGET_EVENT_ID);
